import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const useSponsorsStore = defineCollectionStore({
	id: 'sponsors',
	endpoint: '/api/sponsors',
	dataKey: 'sponsors',
	wrapRecords: true,
	errorLabel: 'Fetch Sponsors Error: ',
	fetchName: 'fetchSponsors',
	archive: {
		toggleName: 'toggleArchivedSponsors',
		archivedDataKey: 'archivedSponsors',
		archivedFetchName: 'fetchArchivedSponsors',
		archivedEndpoint: (year) => `/api/archive/${year}/sponsors`,
		// Verbatim quirk: copy/paste bug in the old store — the archived-fetch catch logs "Fetch Tours Error: ".
		errorLabel: 'Fetch Tours Error: ',
		getters: {
			sponsorsData: 'data',
		},
	},
});
